import React from 'react'
import styled from 'styled-components'
import Graph_Box from '../graphBox/Graph_Box'
import { CardsFull, device } from 'monica-alexandria'

const StatisticsSummary = styled.div`

`

const StatCardsFull = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap:1rem;


    .OnClickBody  h3{
        color: var(--focus)
    }

    @media ${device.lg}{
      grid-template-columns: repeat(3, 1fr);
    }

    @media ${device.md}{
      grid-template-columns: repeat(2, 1fr);
    }
`

const StatisticsSubtitle = styled.div` 
  margin-bottom: 1rem;
`
export default function Statistics_Summary(props) {
  return (
    <StatisticsSummary>
        <StatisticsSubtitle>
          <h4>{props.title}</h4>   
        </StatisticsSubtitle>
    {/* <KpiDates>
            <DropdownWrapper>
            <Dropdown_ label={t('Month')} >
              <select
                value={selectedKpi?.key}
                onChange = {(e) => handleSelectedKpi(e.target.value)}
              >
                {keys?.map((key, i) => (
                    <option key={i} value={key}>
                      {key}
                    </option>
                  ))}
              </select>
            </Dropdown_>
        </DropdownWrapper>
          </KpiDates> */}
        <StatCardsFull>
          <Graph_Box
            kpiValue={props.statistics?.activeTotal || '0'}
            kpiTitle='Total active'
          />
          <Graph_Box
            kpiValue={props.statistics?.activeQuests || '0'}
            // header={lastValue?.activeQuests || '0'}
            kpiTitle='Active Quests'
          />
          <Graph_Box
            kpiValue={props.statistics?.newActiveQuests || '0'}
            kpiTitle='New active Quests'
          />
          <Graph_Box
            kpiValue={props.statistics?.newPaid || '0'}
            kpiTitle='New subscribers'
          />
    
          <Graph_Box
            kpiValue={props.statistics?.returning || '0'}
            kpiTitle='Returning subscribers'
          />
           <Graph_Box
            kpiValue={props.statistics?.lost || '0'}
            kpiTitle='Lost subscribers'
          />
          {/* <Graph_Box
            kpiValue={selectedKpi?.value?.lost || '0'}
            kpiTitle='Lost subscribers'
          /> */}
        </StatCardsFull>
    </StatisticsSummary>
  )
}
